import React, { useState, useEffect } from "react";
import "../../styles/entertainment.css";
import grid_1 from "../../assets/images/webp/grid1.jpg";
import grid_2 from "../../assets/images/webp/grid2.jpg";
import grid_3 from "../../assets/images/webp/grid3.jpg";
import grid_4 from "../../assets/images/webp/grid4.jpg";
import grid_5 from "../../assets/images/webp/grid5.jpg";
import grid_6 from "../../assets/images/webp/grid6.jpg";
import grid_7 from "../../assets/images/webp/grid7.jpg";
import grid_8 from "../../assets/images/webp/grid8.jpg";
import grid_9 from "../../assets/images/webp/grid9.jpg";
import grid_10 from "../../assets/images/webp/grid10.jpg";
import grid_11 from "../../assets/images/webp/grid11.jpg";
import grid_12 from "../../assets/images/webp/grid12.jpg";
import grid_13 from "../../assets/images/webp/grid13.jpg";
import grid_14 from "../../assets/images/webp/grid14.jpg";
import grid_15 from "../../assets/images/webp/grid15.jpg";
import grid_16 from "../../assets/images/webp/grid16.jpg";
import grid_17 from "../../assets/images/webp/grid17.jpg";
import grid_18 from "../../assets/images/webp/grid18.jpg";
import grid_19 from "../../assets/images/webp/grid19.jpg";
import grid_20 from "../../assets/images/webp/grid20.jpg";
import invest_icon1 from "../../assets/images/webp/icon1.jpg";
import invest_icon2 from "../../assets/images/webp/icon2.jpg";
import invest_icon3 from "../../assets/images/webp/icon3.jpg";
import invest_icon4 from "../../assets/images/webp/icon4.jpg";
import invest_icon5 from "../../assets/images/webp/icon5.jpg";
import invest_icon6 from "../../assets/images/webp/icon6.jpg";

const imageSets = [
  [grid_1, grid_6, grid_11, grid_16], // First image slot options
  [grid_2, grid_7, grid_12, grid_17], // Second image slot options
  [grid_4, grid_9, grid_14, grid_19], // Third image slot options
  [grid_5, grid_10, grid_15, grid_20], // Fourth image slot options
  [grid_3, grid_8, grid_13, grid_18], // Large image slot options
];

const GalleryImage = () => {
  const [currentImages, setCurrentImages] = useState([0, 0, 0, 0, 0]);
  const [flipState, setFlipState] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFlipState([true, true, true, true, true]); // Trigger flip animation
      setTimeout(() => {
        setCurrentImages((prevImages) =>
          prevImages.map(
            (currentIndex, slot) => (currentIndex + 1) % imageSets[slot].length
          )
        );
        setFlipState([false, false, false, false, false]); // Reset flip state
      }, 500); // Match this duration with the CSS animation duration
    }, 4000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-black py-5">
      <div className="container">
        <div className="row justify-content-center mt-4 mb-5">
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon1}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                Multilingual film production
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                We bring stories to life across languages, ensuring cultural
                relevance and emotional resonance.
              </p>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon3}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                Landmark Films
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                Our work on landmark films such as Yamuna Putra Angad
                demonstrates our capacity to create content that leaves.
              </p>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon2}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                200+ Music Videos
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                Having produced over 200 music videos, we showcase our ability
                to deliver high-impact visuals and sound
              </p>
            </div>
          </div>

          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon4}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                Regional Studio Collaborations
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                Collaborating with regional studios, we ensure cost-effective
                production without compromising on quality.
              </p>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon5}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                Booming Regional Content Demand
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                The rise in regional language content consumption, driven by
                Tier II and Tier III audiences, offers a lucrative opportunity
                for HKI Entertainment to cater to a growing untapped market.
              </p>
            </div>
          </div>
          <div
            data-aos="fade-up"
            data-aos-duration="2000"
            className=" col-lg-3 col-md-4 col-sm-6  mb-3 mt-5 position-relative"
          >
            <img
              loading="lazy"
              decoding="async"
              width={70}
              height={74}
              className=" position-absolute start-50 translate-middle-x"
              style={{ top: "-40px", zIndex: "3456" }}
              src={invest_icon6}
              alt="invest_icon1"
            />
            <div className="card h-100 p-2 pt-5 text-center darkgraycolor rounded-2">
              <h3
                className="mt-3 fs_20 fw-bold mb-0 ff_s"
                style={{ color: "#FFC107" }}
              >
                Youth and Digital-First Growth
              </h3>
              <p className="fs_18 fw-medium mb-0 mt-2 text-gray-300 ff_n">
                With over 600 million young Indians and the booming ₹30,000
                crore OTT market, HKI Entertainment is strategically poised to
                deliver compelling, culturally resonant content to India’s
                digital-savvy audience.
              </p>
            </div>
          </div>
        </div>
        <h3
          data-aos="fade-up"
          data-aos-duration="2000"
          className="fs_35 fw-bold ff_s text-white text-center mb-0"
        >
          Behind the Scenes
        </h3>
        <div className="row align-items-center gallery_grid mt-5">
          {/* First column */}
          <div className="col-md-6 h-100">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div
                  className={`flip-container ${flipState[0] ? "flipping" : ""}`}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className="flip-image border-1 border border-light"
                    src={imageSets[0][currentImages[0]]}
                    alt="grid_1"
                  />
                </div>
              </div>
              <div className="col-md-5 mt-3 mt-md-0">
                <div
                  className={`flip-container ${flipState[1] ? "flipping" : ""}`}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className="flip-image border-1 border border-light"
                    src={imageSets[1][currentImages[1]]}
                    alt="grid_2"
                  />
                </div>
              </div>
              <div className="col-md-5 mt-3">
                <div
                  className={`flip-container ${flipState[2] ? "flipping" : ""}`}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className="flip-image border-1 border border-light"
                    src={imageSets[2][currentImages[2]]}
                    alt="grid_4"
                  />
                </div>
              </div>
              <div className="col-md-7 mt-3">
                <div
                  className={`flip-container ${flipState[3] ? "flipping" : ""}`}
                >
                  <img
                    loading="lazy"
                    decoding="async"
                    className="flip-image border-1 border border-light"
                    src={imageSets[3][currentImages[3]]}
                    alt="grid_5"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Second column */}
          <div className="col-md-6 h-100 mt-3 mt-md-0">
            <div className={`flip-container ${flipState[4] ? "flipping" : ""}`}>
              <img
                loading="lazy"
                decoding="async"
                style={{ height: "400px" }}
                className=" w-100 object-fit-cover rounded-4 flip-image border-1 border border-light"
                src={imageSets[4][currentImages[4]]}
                alt="grid_3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryImage;
